// Contact cell with hover tooltip for full details

import React from 'react'
import { Box, Typography, Stack, Tooltip } from '@mui/material'
import { Phone as PhoneIcon } from '@mui/icons-material'

import { poolwerxColors } from '../../../theme/colors'
import type { FranchisePartner } from '../types'
import { getFranchiseeName } from '../utils'

interface ContactCellProps {
  fp: FranchisePartner
}

const ContactCell: React.FC<ContactCellProps> = ({ fp }) => {
  const name = getFranchiseeName(fp)
  const hasDetails = fp.franchisee_email || fp.franchisee_mobile

  if (!hasDetails) {
    return <Typography variant="body1" sx={{ fontSize: '0.95rem' }}>{name}</Typography>
  }

  return (
    <Tooltip
      title={
        <Box sx={{ p: 0.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>{name}</Typography>
          {fp.franchisee_email && (
            <Typography
              variant="body2"
              component="a"
              href={`mailto:${fp.franchisee_email}`}
              sx={{ color: 'inherit', display: 'block', '&:hover': { textDecoration: 'underline' } }}
            >
              {fp.franchisee_email}
            </Typography>
          )}
          {fp.franchisee_mobile && (
            <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.5 }}>
              <PhoneIcon sx={{ fontSize: 14 }} />
              <Typography variant="body2">{fp.franchisee_mobile}</Typography>
            </Stack>
          )}
        </Box>
      }
      arrow
      placement="top"
    >
      <Typography
        variant="body1"
        sx={{ cursor: 'pointer', fontSize: '0.95rem', '&:hover': { color: poolwerxColors.teal } }}
      >
        {name}
      </Typography>
    </Tooltip>
  )
}

export default ContactCell
